import Pusher from "pusher-js";

// Pusher configuration
const APP_KEY = "188dd8eaf377e22b0c89";
const CLUSTER = "us2";

// Create a single Pusher instance
const pusher = new Pusher(APP_KEY, {
  cluster: CLUSTER,
  forceTLS: true,
});

// Export the instance for reuse
export default pusher;
